import * as ohm from 'ohm-js';
import { Vector } from 'prelude-ts';

import Statement from './Statement';

import Atom from './formula/Atom';
import One from './formula/One';
import Tensor from './formula/Tensor';
import Zero from './formula/Zero';
import Plus from './formula/Plus';
import Top from './formula/Top';
import With from './formula/With';
import Bottom from './formula/Bottom';
import Par from './formula/Par';
import Lollipop from './formula/Lollipop';

const grammar = ohm.grammar(`
  Statement {
    Statement 
      = ListOf<Formula, ","> "=>" ListOf<Formula, ",">

    Formula
     = Atomic "*" Formula  -- tensor
     | Atomic "+" Formula  -- plus
     | Atomic "&" Formula  -- with
     | Atomic "||" Formula -- par
     | Atomic "-o" Formula  -- lollipop
     | Atomic

    Atomic
      = "(" Formula ")" -- parens
      | "1"             -- one
      | "0"             -- zero
      | "\\\\top"         -- top
      | "\\\\bot"         -- bottom
      | atom

    atom (atom)
      = "-"? letter+
  }`);

const semantics = grammar.createSemantics();

semantics.addAttribute('parsed', {
  Statement: (resources, _implies, requirements) =>
    new Statement(
      Vector.ofIterable(resources.asIteration().parsed),
      Vector.ofIterable(requirements.asIteration().parsed)
    ),

  Formula: e => e.parsed,
  Formula_tensor: (left, _op, right) => new Tensor(left.parsed, right.parsed),
  Formula_plus: (left, _op, right) => new Plus(left.parsed, right.parsed),
  Formula_with: (left, _op, right) => new With(left.parsed, right.parsed),
  Formula_par: (left, _op, right) => new Par(left.parsed, right.parsed),
  Formula_lollipop: (left, _op, right) =>
    new Lollipop(left.parsed, right.parsed),

  Atomic: e => e.parsed,
  Atomic_parens: (_l, e, _r) => e.parsed,
  Atomic_one: _e => new One(),
  Atomic_zero: _e => new Zero(),
  Atomic_top: _e => new Top(),
  Atomic_bottom: _e => new Bottom(),

  atom: (negation, name) =>
    new Atom(name.sourceString, negation.sourceString !== '')
});

export function parse(input: string): Statement {
  const match = grammar.match(input);
  if (match.succeeded()) {
    return semantics(match).parsed;
  } else {
    throw Error(match.message);
  }
}
